export default {"src":"/_next/static/media/icon_arrow.c3171665.svg","height":24,"width":24};